import { createSaveInProgressFormReducer } from '@department-of-veterans-affairs/platform-forms/reducers';
import vapService from '@@vap-svc/reducers';
import formConfig from './config/form';
import { enablePrefillUpdate527ez0969 } from './helpers';

export default {
  form: createSaveInProgressFormReducer(formConfig),
  ...(enablePrefillUpdate527ez0969() && { vapService }),
};
